var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{directives:[{name:"facade",rawName:"v-facade",value:(_vm.$t('base.dateMask')),expression:"$t('base.dateMask')"}],attrs:{"label":_vm.question[("label" + _vm.upperLocale)],"rules":[
        !_vm.required || _vm.requiredField(),
        _vm.isExpectedDueDate ? function (v) { return !v || _vm.getFormRule('futureDate', 'base.errors.dateFuture')(v); } :
        function (v) { return !v || _vm.getFormRule('pastDate', 'base.errors.datePast')(v); },
        function (v) { return !v || _vm.getFormRule('validateDateIsInRange')(v, this$1.maxDate, this$1.minDate); }
    ],"min-width":"290px"},on:{"input":_vm.update},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})}
var staticRenderFns = []

export { render, staticRenderFns }